var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"v-dialog v-dialog--active",class:{ small: _vm.small, medium: _vm.medium, large: _vm.large }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }